var exports = {
  "l": "xe564cbfb--556496--phone",
};

module.exports = exports;
